module.exports = __webpack_public_path__ + "media/images/lb/966-c6aeaa239b5e506180767cefbe8fc005.svg";